import React from "react";
import theme from "theme";
import { Theme, Text, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"privacy-policy"} />
		<Helmet>
			<title>
				Green Bliss Café Franchise
			</title>
			<meta name={"description"} content={"Welcome to Green Bliss Café, the home of plant-based dining where sustainability meets indulgence!"} />
			<meta property={"og:title"} content={"Green Bliss Café Franchise"} />
			<meta property={"og:description"} content={"Місце для тих,Welcome to Green Bliss Café, the home of plant-based dining where sustainability meets indulgence! хто любить біг і прагне відчути силу руху, свободи та спільність з однодумцями."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<meta name={"msapplication-TileColor"} content={"#0CAD1C"} />
		</Helmet>
		<Components.Header3 />
		<Section>
			<Text font="--headline2">
				{"  "}Privacy Policy
			</Text>
			<Text>
				{"  "}At Green Bliss Café, we deeply respect your privacy. This policy outlines how we collect, use, store, and protect your personal information when you visit our website or use our services.
			</Text>
			<Text font="--headline4">
				{"  "}Information We Collect
			</Text>
			<Text>
				We may collect the following types of information:
				<br />
				<br />
				{"  "}- Your name, contact details, and email address.
				<br />
				{"  "}- Information related to your orders, reservations, and preferences for our products and services.
				<br />
				{"  "}- Data regarding your interactions with our website to enhance your experience.
			</Text>
			<Text font="--headline4">
				{"  "}How We Use Your Information
			</Text>
			<Text>
				We use your personal information for the following purposes:
				<br />
				<br />
				{"  "}- To process your orders, reservations, and requests.
				<br />
				{"  "}- To provide you with excellent customer service.
				<br />
				{"  "}- To send promotional offers, newsletters, and updates (only with your consent).
				<br />
				{"  "}- To improve our website, menu, and overall services based on your feedback and preferences.
			</Text>
			<Text font="--headline4">
				{"  "}Data Protection
			</Text>
			<Text>
				{"  "}We take the security of your data seriously. Green Bliss Café employs modern encryption and secure storage technologies to protect your information from unauthorized access, loss, or disclosure.
			</Text>
			<Text font="--headline4">
				{"  "}Sharing Information with Third Parties
			</Text>
			<Text>
				{"  "}We do not share your personal information with third parties except under the following circumstances:
				<br />
				<br />
				{"  "}- When required by law or to comply with legal obligations.
				<br />
				{"  "}- To trusted service providers who assist us in delivering our services (e.g., payment processors or delivery partners), and only to the extent necessary to fulfill your orders.
			</Text>
			<Text font="--headline4">
				{"  "}Your Rights
			</Text>
			<Text>
				As a valued customer, you have the following rights regarding your personal data:
				<br />
				<br />
				{"  "}- Access your personal information and request a copy of it.
				<br />
				{"  "}- Update or delete your personal information.
				<br />
				{"  "}- Opt-out of receiving marketing emails by using the unsubscribe link provided in our communications.
				<br />
				{"  "}- Restrict or object to certain data processing activities.
			</Text>
			<Text font="--headline4">
				{"  "}Policy Updates
			</Text>
			<Text>
				{"  "}Green Bliss Café reserves the right to update this privacy policy at any time. Any changes will be posted on this page, and we encourage you to review it periodically to stay informed.
			</Text>
			<Text font="--headline4">
				{"  "}Contact Us
			</Text>
			<Text>
				If you have any questions or concerns about our Privacy Policy, please feel free to contact us at info@greenbliss.com. We value your trust and are committed to safeguarding your information.
			</Text>
		</Section>
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"614ce40335c5c8001f7746de"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});